import ErrorBoundary from '@components/utils/error-boundary';
import { PanelHistoryContext } from '@context/panel-history';
import { ReduxContext } from '@context/redux';
import { RightSectionContext } from '@context/right-section';
import { usePanelHistory } from '@hooks/panel-history';
import { useRightPanel } from '@hooks/right-section';
import { type IActions } from '@interface/IAction';
import { type IStates } from '@interface/IReducer';
import { type FC, type ReactNode, useMemo } from 'react';

interface IAllProviders {
	states: IStates;
	actions: IActions;
	children?: ReactNode;
}

export const AllProviders: FC<IAllProviders> = ({ children, states, actions }) => {
	const rightPanel = useRightPanel();

	const panelHistoryProps = usePanelHistory(rightPanel);

	return (
		<ErrorBoundary>
			<ReduxContext.Provider value={{ states, actions }}>
				<RightSectionContext.Provider value={rightPanel}>
					<PanelHistoryContext.Provider value={panelHistoryProps}>{children}</PanelHistoryContext.Provider>
				</RightSectionContext.Provider>
			</ReduxContext.Provider>
		</ErrorBoundary>
	);
};
